@if (renderFormWrapper) {
  <form [formGroup]="fG">
    <app-form-input-content
      [type]="type"
      [placeholder]="placeholder"
      [fCN]="fCN"
      [fG]="fG"
      [label]="label"
      [errorText]="errorText"
      [iconFront]="iconFront"
      [iconBack]="iconBack"
      [iconClickType]="iconClickType"
      [iconFrontTooltip]="iconFrontTooltip"
      [iconBackTooltip]="iconBackTooltip"
      [style]="style"
      [disabled]="disabled"
      [cssClass]="cssClass"
      [hasErrorField]="hasErrorField"
      [wrapperClass]="wrapperClass"
      [autocomplete]="autocomplete"
      [inputName]="inputName"
      [layouttype]="layouttype"
      (blurred)="blurred.emit()"
      (returnKeyPress)="returnKeyPress.emit()"
      (iconFrontClick)="iconFrontClick.emit()"
      (iconBackClick)="iconBackClick.emit()"
    >
      <ng-content></ng-content>
    </app-form-input-content>
  </form>
} @else {
  <div>
    <app-form-input-content
      [type]="type"
      [placeholder]="placeholder"
      [fCN]="fCN"
      [fG]="fG"
      [label]="label"
      [errorText]="errorText"
      [iconFront]="iconFront"
      [iconBack]="iconBack"
      [iconClickType]="iconClickType"
      [iconFrontTooltip]="iconFrontTooltip"
      [iconBackTooltip]="iconBackTooltip"
      [style]="style"
      [disabled]="disabled"
      [cssClass]="cssClass"
      [hasErrorField]="hasErrorField"
      [wrapperClass]="wrapperClass"
      [autocomplete]="autocomplete"
      [inputName]="inputName"
      [layouttype]="layouttype"
      (blurred)="blurred.emit()"
      (returnKeyPress)="returnKeyPress.emit()"
      (iconFrontClick)="iconFrontClick.emit()"
      (iconBackClick)="iconBackClick.emit()"
    >
      <ng-content></ng-content>
    </app-form-input-content>
  </div>
}